import loadable from '@loadable/component';

const FloatingMusic = loadable(() => import(/* webpackChunkName: "invitato-floating-music" */ './index'));
export default FloatingMusic;
